<template>
    <div class="useful-links" aria-label="Useful links">
        <div
            v-for="(linkData, index) in links"
            :key="`${linkData.icon}-${index}`"
            class="link"
        >
            <div class="icon">
                <DSIcon
                    :code="linkData.icon"
                    :size="linkData.size || 'xxxl'"
                />
            </div>
            <div class="content">
                <component
                    :is="tag(linkData)"
                    :to="linkData.to"
                    :href="linkData.href"
                    :class="linkData.to || linkData.href ? 'link__title-link' : false"
                    :active-class="linkData.to ? 'link__title-link--active' : null"
                    :exact-active-class="linkData.to ? 'link__title-link--exact-active' : null"
                >
                    <h5 class="link__title text--left">
                        {{ linkData.title }}
                    </h5>

                    <component
                        :is="tag(linkData.subtitle)"
                        v-if="linkData.subtitle"
                        :to="linkData.subtitle.to"
                        :href="linkData.subtitle.href"
                        class="subtitle"
                        :active-class="linkData.to ? 'active' : null"
                        :exact-active-class="linkData.to ? 'exact-active' : null"
                    >
                        <h6
                            v-if="linkData.subtitle || Object.keys(linkData.subtitle).length"
                            class="subtitle text--left"
                        >
                            {{ typeof linkData.subtitle === 'object' ? linkData.subtitle.label : linkData.subtitle }}
                        </h6>
                    </component>
                </component>
                <div
                    v-if="linkData.body"
                    class="body"
                    v-html="linkData.body"
                />
            </div>
        </div>
    </div>
</template>
<script>
import { resolveComponent } from '#imports';

export default {
    name: 'DSUsefulLinks',
    props: {
        links: {
            type: Array,
            required: true,
            validator(links) {
                return links.length && links.length !== 0;
            },
        },
    },
    methods: {
        tag(linkData) {
            return !linkData.to && !linkData.href ? 'span' : resolveComponent('NuxtLink');
        },
    },
};
</script>
<style scoped>
.useful-links {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 2rem;
}
@media (max-width: 1199px) {
  .useful-links {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 991px) {
  .useful-links {
    grid-template-columns: 1fr;
  }
}

.link {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 1rem;
  flex: 1;
  width: 100%;
}
.link:not(:only-child):not(:last-child) {
  margin-bottom: 1rem;
}

.link > .icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0.75rem;
  border-radius: 50%;
  background-color: var(--color-primary-700);
  margin: 1rem 1rem 0 0;
  width: auto;
  height: auto;
  max-height: 3.5rem;
  max-width: 3.5rem;
}
.link .title-link {
  text-decoration: none;
}
.link .title {
  margin-top: 0;
  margin-bottom: 0.25rem;
}
.link :deep(.subtitle) {
  color: var(--color-base-grey-600);
  margin-bottom: 0.5rem;
}
.link .content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.link .body {
  font-size: 14px;
}
</style>
